/* eslint-disable no-console */
import { register } from "register-service-worker";
import { reloadPage } from "@/utils/system";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.VUE_APP_API_URL}service-worker.js`, {
    ready() {
      console.log("App is being served from cache by a service worker.");
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available; please refresh.");
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      reloadPage();
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
